import styled, { css } from "styled-components";

import { ButtonWrapper } from "../button/styles";
import { HtmlWrapper } from "../html/styles";
import { Container } from "../../styles/elements";
import vars from "../../styles/vars";

type TextLinkWrapperProps = {
  $backgroundImage?: string;
};

export const TextLinkWrapper = styled.div<TextLinkWrapperProps>`
  height: 100%;
  background-color: black;
  background-image: ${({ $backgroundImage }) =>
    $backgroundImage ? `url(${$backgroundImage})` : "none"};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  & video {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: auto;
    z-index: 2;

    @media (max-aspect-ratio: 16 / 9) {
      height: 100vh;
      width: auto;
    }
  }

  ${Container} {
    height: 100%;
  }
`;

type LineProps = {
  $alignment: string;
};

export const Line = styled.div<LineProps>`
  position: relative;
  width: 40vw;
  max-width: 280px;
  height: 2px;
  background-color: #fff;

  ${({ $alignment }) => {
    if ($alignment === "left") {
      return css`
        margin: 6vh auto 7vh 0;
      `;
    }
    if ($alignment === "center") {
      return css`
        margin: 6vh auto 7vh auto;
      `;
    }
    if ($alignment === "right") {
      return css`
        margin: 6vh 0 7vh auto;
      `;
    }
  }}
`;

type TitleWrapperProps = {
  $fontSize: string;
};

export const TextLinkContainer = styled.div<TitleWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 3;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  ol {
    list-style-type: upper-alpha;
  }

  ${HtmlWrapper} {
    & h1 {
      font-size: 1.6em;
      font-weight: 600;

      @media (max-width: 600px) {
        font-size: 1.3em;
      }

      ${({ $fontSize }) => {
        if ($fontSize === "small") {
          return css`
            font-size: 1.3em;

            @media (max-width: 600px) {
              font-size: 1em;
            }
          `;
        }
        if ($fontSize === "large") {
          return css`
            font-size: 1.9em;

            @media (max-width: 600px) {
              font-size: 1.6em;
            }
          `;
        }
      }}
    }

    & p {
      margin-bottom: 1em;
      line-height: 1.3;
      font-size: 1em;

      .ql-size-small {
        font-size: 0.75em;
      }

      .ql-size-normal {
        font-size: 1em;
      }

      .ql-size-large {
        font-size: 1.2em;
      }

      & .ql-size-huge {
        font-size: 1.6em;
      }

      @media (max-width: 600px) {
        font-size: 0.8em;

        .ql-size-small {
          font-size: 0.6em;
        }

        .ql-size-normal {
          font-size: 0.8em;
        }

        .ql-size-large {
          font-size: 1em;
        }

        & .ql-size-huge {
          font-size: 1.3em;
        }
      }
    }
  }
`;

export const TextWrapper = styled.div`
  max-width: 920px;
  margin: auto;
  padding-top: 22vh;
  padding-left: 1em;
  padding-right: 1em;

  @media (max-width: 500px) {
    padding-top: 22vw;
  }
`;

export const TitleWrapper = styled.div`
  ${HtmlWrapper}:first-child {
    font-family: ${vars.fontPrimary};
  }
`;

type ButtonContainerProps = {
  $alignment: string;
  $hasMaxWidth?: boolean;
};

export const ButtonContainer = styled.div<ButtonContainerProps>`
  margin-bottom: 40px;
  max-width: 920px;
  margin: 7vh auto 40px auto;
  width: 100%;
  display: flex;
  align-items: center;

  ${({ $alignment }) => {
    if ($alignment === "center") {
      return css`
        justify-content: center;
      `;
    }
    if ($alignment === "right") {
      return css`
        justify-content: flex-end;
      `;
    }
  }}

  & ${ButtonWrapper} {
    border: none;
    margin-right: 1em;
    &:last-child {
      margin-right: 0;
    }
  }
`;
